import {
  createBrowserRouter,
  MiddlewareFunction,
  Navigate,
  redirect,
  RouterProvider,
  type RouteObject,
} from 'react-router';

import { SetTimezonePage } from '@/pages/set-timezone';
import { Plug } from '@/shared/ui';

import {
  AuthorizedContext,
  AuthorizedLayout,
} from '@/true-fsd/layout/Authorized';
import { LoginCallbackPage } from '@/true-fsd/layout/LoginCallbackPage';
import { LoginPage } from '@/true-fsd/layout/LoginPage';

import { queryClient } from '../providers/queryClient';
import '../styles/index.scss';

import { Loading } from './components/Loading';
import { account } from './routes/account';
import { workspace } from './routes/workspace';
// import { RoutesProvider } from './useAppPathname/provider';
import {
  allLoader,
  accountPath,
  ROOT_PATH,
  workspacePath,
} from '@/true-fsd/data/advertiser-account';
import { useDefaultAccountAndWorkspace } from '@/true-fsd/data/advertiser-account/react-query';
import { isAuthenticated } from '@/true-fsd/data/isAuthenticated';

import { completePrefixPathMw } from './history-store/history-tree-store';
import { AuthorizedErrorBoundary } from './guards/AuthorizedErrorBoundary';
import { RootErrorBoundary } from './guards/RootErrorBoundary';
import { newAccountChannelRequest } from './routes/channel-request';

const HomeRedirect = () => {
  //redirect to existent account or workspace, if any
  const { account, workspace } = useDefaultAccountAndWorkspace();

  let to: string;

  if (workspace) {
    to = workspacePath(workspace);
  } else if (account) {
    to = accountPath(account, 'workspace/new');
  } else {
    to = ROOT_PATH.accountNew;
  }

  return <Navigate to={to} replace />;
};

const isAuthenticatedMw: MiddlewareFunction = (_ctx, next) => {
  if (!isAuthenticated()) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect('/login');
  }

  return next();
};

const routesDeclaration = [
  {
    ErrorBoundary: RootErrorBoundary,
    children: [
      { path: 'login', Component: LoginPage },
      { path: 'login-callback', Component: LoginCallbackPage },
      { path: 'set-timezone', Component: SetTimezonePage },
      {
        Component: AuthorizedContext,
        loader: allLoader(queryClient),
        shouldRevalidate: () => false,
        HydrateFallback: Loading,
        middleware: [isAuthenticatedMw, completePrefixPathMw],
        children: [
          {
            ErrorBoundary: AuthorizedErrorBoundary,
            Component: AuthorizedLayout,
            children: [
              newAccountChannelRequest,
              workspace,
              account,
              {
                index: true,
                Component: HomeRedirect,
              },
              {
                path: '*',
                Component: HomeRedirect,
              },
            ],
          },
        ],
      },
    ],
  },
] satisfies RouteObject[];

const router = createBrowserRouter(routesDeclaration);

export const AppRouter = () => {
  return (
    <div className="app">
      <Plug />
      <div className="app__content">
        <RouterProvider router={router} />
      </div>
    </div>
  );
};
